import * as formatHelper from "../../helpers/formatHelper";

/**
 * @class Price
 */
export default class Price {
    /**
     * @param {String}  id
     * @param {Number}  price
     * @param {String}  currency
     * @param {String}  currencySymbol
     * @param {String}  caption
     * @param {Boolean} withVat
     * @param {Number}  vat
     * @param {Boolean} visible
     */
    constructor(id, price, currency, currencySymbol, caption, withVat, vat, visible = true) {
        this._id = id;
        this._price = price;
        this._currency = currency;
        this._currencySymbol = currencySymbol;
        this._caption = caption;
        this._withVat = withVat;
        this._vat = vat;
        this._visible = visible;

        if (typeof this._id !== "string") {
            throw new Error("Invalid datatype of ID - Price");
        }
    }

    /**
     * @return {String}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {String} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Number}
     */
    get price() {
        return this._price;
    }

    /**
     * @param {Number} price
     */
    set price(price) {
        this._price = price;
    }

    /**
     * @return {String}
     */
    get currency() {
        return this._currency;
    }

    /**
     * @param {String} currency
     */
    set currency(currency) {
        this._currency = currency;
    }

    /**
     * @return {String}
     */
    get currencySymbol() {
        return this._currencySymbol;
    }

    /**
     * @param {String} currencySymbol
     */
    set currencySymbol(currencySymbol) {
        this._currencySymbol = currencySymbol;
    }

    /**
     * @return {String}
     */
    get caption() {
        return this._caption;
    }

    /**
     * @param {String} caption
     */
    set caption(caption) {
        this._caption = caption;
    }

    /**
     * @return {Boolean}
     */
    get withVat() {
        return this._withVat;
    }

    /**
     * @param {Boolean} withVat
     */
    set withVat(withVat) {
        this._withVat = withVat;
    }

    /**
     * @return {Number}
     */
    get vat() {
        return this._vat;
    }

    /**
     * @param {Number} vat
     */
    set vat(vat) {
        this._vat = vat;
    }

    /**
     * @return {Boolean}
     */
    get visible() {
        return this._visible;
    }

    /**
     * @param {Boolean} visible
     */
    set visible(visible) {
        this._visible = visible;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Price (" + this._id + ")";
    }

    /**
     * @return {String}
     */
    formatPrice() {
        return formatHelper.formatCurrency(this._price);
    }

    /**
     * @return {String}
     */
    formatVat() {
        return formatHelper.formatCurrency(this._vat);
    }
}
